<template>
  <div class="home-content" @click="handleClick">
    <Head ref="head" :backFn="back"></Head>
    <div :class="[isMaxScreen ? 'pc_privacy-policy-container' : 'privacy-policy-container']">
      <div class="page-title">POLÍTICA DE PRIVACIDAD</div>
      <div class="page-text-container" v-html="workData"></div>
    </div>
    <bottom ref="bottom"></bottom>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Head from '../../components/head'
import Bottom from '../../components/bottom'
import { enData } from './enData.js'
import { esData } from './esData.js'
import { isES } from '@/locales';
export default {
  name: 'Home',
  components: {
    Head,
    Bottom
  },
  data () {
    return {
      isES
    }
  },
  computed: {
    ...mapState({
      isMaxScreen: state => {
        return state.isMaxScreen
      },
      workData(){
        return this.isES ? esData : enData
      }
    })
  },
  mounted(){
    window.scrollTo(0, 0);
  },
  methods: {
    handleClick(){
      this.$refs.head.hidLangeList();
    },
    back(){
      this.$router.push({ name: 'Home' });
    },
    // 跳转页面
    toPage (name) {
      if (!this.checked && name === 'Product') return
      this.$router.push({ name });
    },
  }
}
</script>
<style scoped lang="less">
@media (min-width: 981px) {
  .home-content {
    width: 100%;
    min-height: 100%;
    background: #FFF;
    font-family: "PingFang SC";
    .pc_privacy-policy-container{
      padding: 160px 0 120px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .page-title{
        color: #252629;
        text-align: center;
        font-family: "PingFang SC";
        font-size: 40px;
        font-style: normal;
        font-weight: 500;
        line-height: 150%;
        margin-bottom: 20px;
      }
      /deep/.page-text-container{
        max-width: 1400px;
        margin: auto;
        .paragraph{
          margin-bottom: 32px;

          .title{
            color:  #252629;
            font-family: "PingFang SC";
            font-size: 24px;
            font-style: normal;
            font-weight: 500;
            line-height: 150%;
            margin-bottom: 12px;
          }
          .text-box{
            .text{
              color: #8F949D;
              font-family: "PingFang SC";
              font-size: 16px;
              font-style: normal;
              font-weight: 400;
              line-height: 150%;
              .email{
                color: #165DFF;
                font-family: "PingFang SC";
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                line-height: 150%;
                cursor: pointer;
              }
            }
          }
        }

      }
    }
  }
}
@media (max-width: 980px) {
.home-content {
  width: 100%;
  min-height: 100%;
  background: #FFF;
  font-family: "PingFang SC";
  .privacy-policy-container{
    padding:148px 30px 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .page-title{
      color: #252629;
      text-align: center;
      font-family: "PingFang SC";
      font-size: 48px;
      font-style: normal;
      font-weight: 500;
      line-height: 150%;
      margin-bottom: 48px;
    }
    /deep/.page-text-container{
      width: 100%;
      .paragraph{
        margin-bottom: 32px;

        .title{
          color:  #252629;
          font-family: "PingFang SC";
          font-size: 32px;
          font-style: normal;
          font-weight: 500;
          line-height: 150%;
          margin-bottom: 24px;
        }
        .text-box{
          .text{
            color: #8F949D;
            font-family: "PingFang SC";
            font-size: 28px;
            font-style: normal;
            font-weight: 400;
            line-height: 150%;
            .email{
              color: #165DFF;
              font-family: "PingFang SC";
              font-size: 28px;
              font-style: normal;
              font-weight: 400;
              line-height: 150%;
              cursor: pointer;
            }
          }
        }
      }

    }
  }
}

}
</style>
